export const getEventPairInterval = (start) => {
    if (start.includes('WWW') && start.includes('MMM') && start.includes('DD') && start.includes('RRRR') && !start.includes('**:**:**')) {
        return 'day'
    }

    if(!start.includes('WWW') && start.includes('MMM') && start.includes('DD') && start.includes('RRRR') && !start.includes('**:**:**')) {
        return 'week'
    }

    if (start.includes('WWW') && start.includes('MMM') && !start.includes('DD') && start.includes('RRRR') && !start.includes('**:**:**')) {
        return 'month'
    }

    if(start.includes('WWW') && !start.includes('MMM') && !start.includes('DD') && !start.includes('**:**:**') && start.includes('RRRR')) {
        return 'year'
    }

    if(start.includes('WWW') && !start.includes('MMM') && !start.includes('DD') && !start.includes('**:**:**') && !start.includes('RRRR')) {
        return 'once'
    }
}